export const GOOGLE_MAPS_CONFIG = {
  apiKey: 'AIzaSyAlZ_1_78SOhGhDg9tD4K6kohBTl_LyD5Q',
  version: 'weekly',
  libraries: ['places'] as const
};